import { IAdditionalChargeRule } from "./additionalChargeRules";

export const calculateCharge = (
  bands: any,
  additionalChargeRule: IAdditionalChargeRule | undefined,
  propertyValue: number
) => {
  const upperBoundaries: number[] = Reflect.ownKeys(bands).map(Number);

  const totalCharge = upperBoundaries.reduce((acc, upperBound, i, arr) => {
    const previousBound = arr[i - 1] || 0;
    const chunkStart = previousBound;
    const amountAboveChunkStart = Math.max(propertyValue - chunkStart, 0);

    if (amountAboveChunkStart === 0) {
      return acc + 0;
    }

    if (upperBound === Infinity) {
      return acc + amountAboveChunkStart * bands[upperBound];
    }

    const chunkEnd = upperBound;
    const chunkRange = chunkEnd - chunkStart;

    const valueInRange = amountAboveChunkStart - chunkRange;

    const chunk = valueInRange > 0 ? chunkRange : Math.abs(chunkRange + valueInRange);
    const modifier = bands[upperBound];

    const contributionToCharge = chunk > 0 ? chunk * modifier : 0;

    return acc + contributionToCharge;
  }, 0);

  const additionalCharge = additionalChargeRule
    ? additionalChargeRule[1](propertyValue)
    : 0;

  return Math.round((totalCharge + additionalCharge + Number.EPSILON) * 100) / 100;
};
